//@ts-nocheck
//@ts-nocheck
import React from "react";
import {
  useToast,
  Box,
  Heading,
  Divider,
  BoxProps,
  useColorModeValue,
} from "@chakra-ui/react";

export const Card = (props: BoxProps) => (
  <Box
    bg={useColorModeValue("white", "gray.700")}
    shadow="base"
    // maxW="2xl"
    mx="auto"
    px={{ base: 4, md: 8 }}
    pt="6"
    pb="8"
    borderTopWidth="2px"
    borderColor={useColorModeValue("gray.300", "gray.500")}
    borderTopColor={useColorModeValue("blue.500", "blue.300")}
    borderBottomRadius={{ base: "none", sm: "base" }}
    {...(props as any)}
  />
);

export const CardContainer = ({ heading, children }) => {
  return (
    // <Box as="section" py="12" bg={useColorModeValue("gray.100", "gray.800")}>
    // <Box maxW="7xl" mx="auto" px={{ sm: "8" }}>
    <Box>
      <Card>
        <Heading size="md" mb="4">
          {heading}
        </Heading>
        <Divider mb="6" />
        {children}
      </Card>
    </Box>
    // </Box>
  );
};
